import { gql } from '@apollo/client'

export const EDIT_GROUP_MEMBER = gql`
  mutation EditGroupMember($inputData: EditGroupMemberInput!) {
    editGroupMember(inputData: $inputData) {
      id
    }
  }
`
